import React from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react'
import ApiIcon from '../../../../../../icons/apiIcon'
import SDKIcon from '../../../../../../icons/sdkIcon'
import WebhookIcon from '../../../../../../icons/webhookIcon'
import IconCap from '../../../../../IconCap/IconCap'

const iconFiles = {
  ApiIcon: <ApiIcon />,
  SDKIcon: <SDKIcon />,
  WebhookIcon: <WebhookIcon />,
} as any

interface ProductOfferingProps {
  data: string[]
}

const ProductOffering: React.FC<ProductOfferingProps> = ({ data }) => {
  return (
    <>
      <Container>
        <Row>
          {data.map((tile: any) => (
            <Col xs={12} lg={4} key={tile.key}>
              <IconCap
                title={tile.title}
                icon={iconFiles[tile.icon]}
                description={tile.description}
                links={tile.links}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </>
  )
}

ProductOffering.displayName = 'ProductOffering'

export default ProductOffering
